// Libraries
var React = require("react");

// Style
require("./Headline.scss");

class HeadlineModule extends React.Component {
  render() {
    return (
      <div
        id={this.props.data.id}
        className={`c-headline  ${
          this.props.data.isPremium ? " c-headline--premium" : ""
        }`}
      >
        <div className="c-headline__bg">
          <div className="c-headline__inner">
            <h1 className="c-headline__title">{this.props.data.title}</h1>
            <div className="c-headline__content">
              <p className="c-headline__text">{this.props.data.text}</p>
            </div>
          </div>
          {this.props.children}
        </div>
      </div>
    );
  }
}

module.exports = HeadlineModule;



// WEBPACK FOOTER //
// ./src/components/Headline/Headline.js